import { NavLink, useNavigate } from "react-router-dom"

const toggleDarkMode = () => document.documentElement.classList.toggle('dark')



export const Header = () => {

   const navigate = useNavigate();

    return (
        <nav
            className="sticky top-0 z-50 bg-white/90 dark:bg-background-dark/90 backdrop-blur-md border-b border-slate-200 dark:border-slate-800">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center h-20">
                    <div className="flex items-center gap-3">
                        <div className="font-display font-bold text-4xl" style={{color: 'rgb(242, 109, 33)'}}>FJ</div>
                        <div className="hidden sm:block">
                            <span
                                className="font-display text-2xl font-bold tracking-tighter text-slate-900 dark:text-white uppercase"
                                >Flacon Jeans</span>
                            <p className="text-[10px] uppercase tracking-[0.2em] font-semibold text-primary">Since 2007
                            </p>
                        </div>
                    </div>
                    <div className="hidden md:flex items-center space-x-8">
                        <NavLink className="text-sm font-semibold hover:text-primary transition-colors uppercase tracking-wider" to="/">Home</NavLink>
                        <NavLink className="text-sm font-semibold hover:text-primary transition-colors uppercase tracking-wider" to="/about">About Us</NavLink>
                        <NavLink className="text-sm font-semibold hover:text-primary transition-colors uppercase tracking-wider" to="/womens-jeans">Women's Jeans</NavLink>
                        <button onClick={() => navigate("/contact")} className="bg-primary hover:bg-orange-600 text-white px-6 py-2.5 rounded font-bold uppercase text-xs tracking-widest transition-all">
                            Inquiry
                        </button>
                        <button onClick={toggleDarkMode} className="p-2 rounded-full hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors">
                            <span className="material-icons text-xl">dark_mode</span>
                        </button>
                    </div>
                    <div className="md:hidden flex items-center gap-4">
                        <button onClick={toggleDarkMode} className="p-2">
                            <span className="material-icons">dark_mode</span>
                        </button>
                        <span className="material-icons text-3xl">menu</span>
                    </div>
                </div>
            </div>
        </nav>
    )
}